import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_SERVICE,
})
export {
  axiosInstance
}
